export function resetScrollPosition() {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
}

export function resetScrollAfterRender() {
  const frame = window.requestAnimationFrame(resetScrollPosition);

  return () => {
    window.cancelAnimationFrame(frame);
  };
}
